import Backbone from "@src/backbone/prototypes/Backbone";
import LocalStorageModel from "../prototypes/LocalStorageModel";
import {
  EMacaronTemplate,
  IMacaronTemplate,
} from "design-system/src/Core/ProductBlock/MacaronBadge/MacronBadge.interface";
export interface IMacaronModelAttributes extends Backbone.ObjectHash {
  id_macaron: string;
  name?: string;
  color?: string;
  template?: IMacaronTemplate;
}

class MacaronModel extends LocalStorageModel<IMacaronModelAttributes> {
  name = "MacaronModel";
  route = "apiMacaronModel";
  idAttribute = "id_macaron";

  initialize(attributes?: any, options?: any): void {
    const model = this;
    super.initialize.apply(model, [attributes, options]);
  }

  getName(): string {
    return this.get("name") || "";
  }

  getColor(): string {
    return this.get("color") || "";
  }

  getTemplate(): IMacaronTemplate {
    return this.get("template") || EMacaronTemplate.CLASSIC;
  }
}

MacaronModel.prototype.name = "MacaronModel";
MacaronModel.prototype.idAttribute = "id_macaron";

export default MacaronModel;
